<template>
  <div class="container">
    <PublicHeader :totalName="$t('finance').financeProduct" rightRouter="FinanceList" rightIco="history" noLeft />
    <!-- 产品列表 -->
    <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getProductList" :immediate-check="false">
      <div class="item" v-for="(item, index) in pList" :key="`fpro${index}`">
        <div class="nameInfo">
          <img class="imgn" :src="baseUrl + item.img" />
          <div class="right">
            <div class="name">{{item.name}}</div>
            <div class="yield">
              <div class="txt">{{$t('finance').term}}<span>{{item.days}} {{$t('finance').day}}</span></div>
              <div class="btn" @click="$router.push({ name: 'FinanceInfo', query: { id: item.financingId } })">{{ $t('finance').Applynow }}</div>
            </div>
          </div>
        </div>
        <div class="yieldInfo">
          <div class="txtss"><span>{{$t('finance').Mininvestment}}</span><span>{{$t('finance').Dailyinterestrate}}</span></div>
          <div class="num"><span>{{ item.lowAmount }}</span><span>{{ item.yieldMin }}% - {{ item.yieldMax }}%</span></div>
        </div>
      </div>
    </van-list>
    <TabBar :active="'Finance'" />
  </div>
</template>

<script>
import productApi from '@/api/product'
import TabBar from '@/components/tabBar'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    TabBar,
    PublicHeader
  },
  data() {
    return {
      baseUrl: window.baseURL,
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],
    }
  },
  mounted() {
    this.getProductList()
  },
  methods: {
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      const res = await productApi.getFinanceProductList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding-top: 50px;
  padding-bottom: 125px;
  background: var(--background_color);

  .item {
    padding: 15px;
    border-bottom: 1px solid var(--info_color);

    .nameInfo {
      display: flex;
      align-items: center;

      .imgn {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        margin-right: 15px;
      }

      .right {
        width: 100%;
        .name {
          font-size: 15px;
          font-weight: bold;
          color: var(--text_color);
        }
        .yield {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .txt {
            font-size: 13px;
            color: var(--ntext_color);

            span {
              margin-left: 5px;
              color: var(--text_color);
            }
          }

          .btn {
            padding: 5px 10px;
            border-radius: 10px;
            font-size: 10px;
            font-weight: normal;
            color: #fff;
            background: var(--primary_color);
          }
        }
      }
    }

    .yieldInfo {
      margin-top: 10px;
      background: var(--info_color);
      padding: 15px;
      border-radius: 5px;

      .txtss {
        font-size: 12px;
        color: var(--ntext_color);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .num {
        margin-top: 15px;
        font-size: 12px;
        color: var(--text_color);
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
}
</style>
